export type FieldMobileTab = 'home' | 'report' | 'inspection' | 'tbm';

export const fieldMobileTabs = [
  { id: 'home', label: '홈' },
  { id: 'inspection', label: '점검·조치' },
  { id: 'tbm', label: 'TBM' },
  { id: 'report', label: '신고·건의' },
] as const satisfies readonly { id: FieldMobileTab; label: string }[];

export function fieldMobileTabFromPath(pathname: string): FieldMobileTab {
  const candidate = pathname.split('/').filter(Boolean)[1];
  return fieldMobileTabs.some((tab) => tab.id === candidate)
    ? (candidate as FieldMobileTab)
    : 'home';
}

// Presentation scope only; server role/site authorization still applies.
export function isFieldMobileFeature(id: string) {
  return ['tbm', 'inspection-reporting', 'inspection-unresolved', 'finding-action'].includes(id);
}

export function fieldMobilePath(tab: FieldMobileTab) {
  return `/field/${tab}`;
}

export type FieldMobileEntitlements = Readonly<{
  tbm: boolean;
  inspection: boolean;
  findings: boolean;
  report: boolean;
}>;

export type FieldMobileActionId =
  | 'tbm'
  | 'inspection-list'
  | 'quick-inspection'
  | 'my-remediation'
  | 'report';

const actionsByTab: Readonly<Record<FieldMobileTab, readonly {
  id: FieldMobileActionId;
  entitlement: keyof FieldMobileEntitlements;
}[]>> = {
  home: [
    { id: 'quick-inspection', entitlement: 'inspection' },
    { id: 'my-remediation', entitlement: 'findings' },
  ],
  tbm: [
    { id: 'tbm', entitlement: 'tbm' },
  ],
  inspection: [
    { id: 'inspection-list', entitlement: 'inspection' },
    { id: 'my-remediation', entitlement: 'findings' },
  ],
  report: [{ id: 'report', entitlement: 'report' }],
};

export function allowedFieldMobileActionIds(
  tab: FieldMobileTab,
  entitlements: FieldMobileEntitlements,
  contractorView = false,
) {
  const allowed = actionsByTab[tab]
    .filter((action) => entitlements[action.entitlement])
    .map((action) => action.id);
  if (tab !== 'inspection') return allowed;
  const order: readonly FieldMobileActionId[] = contractorView
    ? ['my-remediation', 'quick-inspection', 'inspection-list']
    : ['quick-inspection', 'my-remediation', 'inspection-list'];
  return order.filter(id => allowed.includes(id));
}
